'use client';
import { datadogRum } from '@datadog/browser-rum';
import { InitCompass } from '@nerdwallet/compass/next-init-compass';
import { env } from '@ria-client/env';
import { useAnalytics } from '@ria-client/segment/Analytics';
import { useAnalyticsPageView } from '@ria-client/segment/Analytics/AnalyticsPageView';
import { type PropsWithChildren, type ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export function CompassPageViewRegistration({
  children,
}: PropsWithChildren): ReactNode | undefined {
  const { pageViewId, pageName, contentId, contentSource } = useAnalyticsPageView();
  const { deployableName, deployableVersion } = useAnalytics();

  const renderInitCompass = () => {
    return (
      <ErrorBoundary
        fallback={<div />}
        onError={error => {
          datadogRum.addError(error, { message: 'Error initializing Compass' });
        }}
      >
        <InitCompass
          pageViewId={pageViewId}
          deployableName={deployableName}
          deployableVersion={deployableVersion}
          writeKey={env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}
          driverContentId={contentId}
          driverContentSource={contentSource}
          driverPageName={pageName}
          enableScrollDepthTracking={true}
          enableUserIsActiveTracking={true}
          userIsActiveInactivityThreshold={60000}
        />
      </ErrorBoundary>
    );
  };

  return (
    <>
      {children}
      {renderInitCompass()}
    </>
  );
}
